import { findPort } from '../../trace/ports.js';
import { defineRule } from '../rule.js';

/** E: a connection refers to a missing item, port or sub-core. */
export const connectionDangling = defineRule(
  'connection-dangling',
  'error',
  { en: 'Connection to missing port', de: 'Verbindung zu fehlendem Anschluss' },
  (data, emit) =>
    Object.values(data.connections).flatMap((c) => {
      const missing = [c.from, c.to]
        .filter((end) => findPort(data, end.itemId, end.portId) === undefined)
        .map((end) => `${end.itemId}/${end.portId}`);
      if (c.via !== undefined && data.items[c.via.itemId] === undefined) missing.push(c.via.itemId);
      if (missing.length === 0) return [];
      const items = [c.from.itemId, c.to.itemId].filter((id) => data.items[id] !== undefined);
      return [emit([c.id, ...items], { missing: missing.join(', ') })];
    }),
);
